import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import Cookies from 'js-cookie';
var accountTypesKey = 'account_types';
var tokenKey = 'access_token';
var languageKey = 'language';
var xToken = 'X-Token';
export var utilCookies = {
  setAccountTypes: function setAccountTypes(accountTypes) {
    Cookies.set(accountTypesKey, accountTypes);
  },
  getAccountTypes: function getAccountTypes() {
    return Cookies.get(accountTypesKey);
  },
  setToken: function setToken(Token) {
    Cookies.set(tokenKey, Token);
  },
  getToken: function getToken() {
    return Cookies.get(tokenKey);
  },
  removeToken: function removeToken() {
    return Cookies.remove(tokenKey);
  },
  setLanguage: function setLanguage(language) {
    Cookies.set(languageKey, language);
  },
  getLanguage: function getLanguage() {
    return Cookies.get(languageKey);
  },
  getCompanyToken: function getCompanyToken() {
    return Cookies.get(xToken);
  },
  setCompanyToken: function setCompanyToken(Token) {
    Cookies.set(xToken, Token);
  },
  removeCompanyToken: function removeCompanyToken() {
    return Cookies.remove(xToken);
  },
  clear: function clear() {
    Object.keys(Cookies.get()).forEach(function (cookieName) {
      return Cookies.remove(cookieName);
    });
  }
};